<template>
  <label class="rumie-checkbox">
    <slot></slot>
    <input type="checkbox" :checked="value" @change="(e) => $emit('input', e.target.checked)" :disabled="disabled">
    <span class="checkbox__label" :class="checkboxClass"></span>
  </label>
</template>

<script>
export default {
  name: "RumieCheckbox",
  props: {
    value: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    partial: Boolean
  },
  computed: {
    checkboxClass() {
      return {
        "checkmark": this.value,
        "outlined": this.outlined,
        "partial": this.partial
      };
    },
  }
};
</script>

<style scoped>
.rumie-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: var(--base);
  user-select: none;
  margin: var(--spacing-2) 0;
}

.rumie-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox__label {
  position: absolute;
  top: var(--spacing-1);
  left: 0;
  height: 25px;
  width: 25px;
  background-color: var(--grey-lighter);
  border-radius: var(--border-radius-md);
  box-sizing: border-box;
}

.rumie-checkbox input:disabled + .checkbox__label {
  opacity: var(--opacity-50);
}


/* outlined */
.rumie-checkbox input ~ .outlined {
  border-radius: 0;
  background-color: var(--transparent);
  border: 2px solid var(--grey-color-icon);
}

/* checked */
.rumie-checkbox input:checked ~ .checkmark {
  border: none;
  background-color: var(--primary);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.rumie-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.rumie-checkbox .checkmark:after {
  left: 10px;
  top: 6px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* partial */
.partial:after {
  content: "";
  position: absolute;
  display: block;
  left: 8px;
  top: 4px;
  width: 3px;
  height: 7px;
  border: solid var(--grey-color-icon);
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
